import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=8f5557a4&scoped=true&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"
import style0 from "./swiper.vue?vue&type=style&index=0&id=8f5557a4&lang=less&scoped=true&"
import style1 from "./swiper.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5557a4",
  null
  
)

export default component.exports